import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const TeamStatSummaryContext = createContext<{
  params?: Routing.TeamStatSummaryParams
}>({})

export { TeamStatSummaryContext }
